<template>
  <div class="wrap">
    <div class="title">
      <h3>附件库</h3>
      <el-button size="mini" @click="openUploaderDialog = true"
        >添加附件</el-button
      >
    </div>
    <div class="li" v-for="(file, index) in fileData">
      <div class="time">{{ file.createTime }}</div>
      <div class="name">
        {{ file.fileName ? file.fileName : file.accessoryUrl }}
      </div>
      <div class="button">
         <el-link type="primary" :href="file.accessoryUrl" target="_blank">下载</el-link>
        <el-link type="danger" @click="deleteFile(file.id)">删除</el-link>
      </div>
    </div>

    <div class="file_null" v-if="fileData.length===0">无附件</div>

    <el-dialog
      :title="$lange == 'en' ? 'Upload attachments' : '上传附件'"
      :visible.sync="openUploaderDialog"
      width="400px"
      append-to-body
    >
      <template v-if="openUploaderDialog">
        <div class="uploader">
          <cc-uploader
            :config="uploaderConf2"
            uploadType="dottedMultiple"
            @upload-success="uploadTrue"
            :isMultiple="false"
          />
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    orderId: String,
  },
  data() {
    return {
      openUploaderDialog: false,
      uploaderConf2: this.$uploadUtils.config, //文件上传需要
      fileData: [],
    };
  },
  methods: {
    getFile() {
      let data = {
        workOrderId: this.orderId,
      };
      this.ccRequest
        .do("admin/fsb/work/order/getAccessoryInfo", data, "GET")
        .then((res) => {
          this.fileData = res;
        });
    },
    uploadTrue(e) {
      console.log(e, "uploadTrue11111");

      let data = {
        objId: this.orderId,
        objType: "workOrderOther",
        accessoryUrl: e.accessoryUrl,
        fileName: e.fileName,
      };
      this.ccRequest
        .do("admin/fsb/accessory/save", data, "POSTJSON")
        .then((res) => {
          this.getFile();
          this.openUploaderDialog = false;
        });
    },
    deleteFile(id) {
      this.$confirm('确认删除该附件？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ccRequest
            .do("admin/fsb/accessory/delete", {id:id}, "GET")
            .then((res) => {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getFile()
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    this.getFile();
  },
};
</script>
<style scoped lang="scss">
.wrap {
  padding: 20px;
}
.title {
  display: flex;
  align-items: center;
  h3 {
    margin-right: 100px;
  }
}
.li {
  margin-top: 20px;
  display: flex;
  align-items: center;
  .time {
    width: 180px;
  }
  .name {
    width: 400px;
  }
  .button {
    display: flex;
    justify-content: space-between;
    width: 70px;
  }
}
.file_null {
  margin-top: 10px;
}
</style>